<template>
  <div class="custom-modal-wrapper">
    <div class="custom-modal-backdrop"></div>
    <div class="custom-modal">
      <div class="custom-modal-close-icon" @click="onClose">
        <b-icon icon="x-lg"></b-icon>
      </div>

      <div class="content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomModal',
  methods: {
    onClose() {
      this.$emit('onClose');
    },
  },
};
</script>

<style scoped>
.custom-modal-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  font-family: var(--primary-font);
  -webkit-font-smoothing: antialiased;
  padding: 30px;
}
.custom-modal-wrapper .custom-modal-backdrop {
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.custom-modal-wrapper .custom-modal {
  background: #ffffff;
  position: relative;
  z-index: 1;
  border-radius: 8px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  max-width: 100%;
}

.custom-modal-wrapper .custom-modal-close-icon {
  position: absolute;
  top: 24px;
  right: 24px;
  z-index: 999;
  cursor: pointer;
  color: #a3a3a3;
}

.custom-modal-wrapper .content {
  width: 100%;
  height: 100%;
}
</style>
